import React, { createContext, useContext, useMemo, useState } from "react";
import { logoutUser } from "./auth";

const AuthContext = createContext(null);

const getStoredUser = () => {
    try {
        const raw = localStorage.getItem("authUser");
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

export function AuthProvider({ children }) {
    const [user, setUser] = useState(() => getStoredUser());

    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return !!getStoredUser() || !!localStorage.getItem("token");
    });

    const login = (userOrToken) => {
        if (typeof userOrToken === "string") {
            localStorage.setItem("token", userOrToken);
            setUser(null);
        } else if (userOrToken) {
            localStorage.setItem("authUser", JSON.stringify(userOrToken));
            setUser(userOrToken);
        }

        setIsAuthenticated(true);
    };

    const logout = async () => {
        setUser(null);
        setIsAuthenticated(false);
        localStorage.removeItem("authUser");
        localStorage.removeItem("token");

        await logoutUser({ callBackend: true });
    };

    const value = useMemo(
        () => ({
            user,
            isAuthenticated,
            login,
            logout
        }),
        [user, isAuthenticated]
    );

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within <AuthProvider>");
    return ctx;
}